import jQuery from "jquery";
import moment from "moment";
import React from "react";
import ReactDOM from "react-dom";
import DateRangePicker from "daterangepicker";
import FocusTrap from "../../../../javascript/utils/modal-focus-trap";
import { FilterMenuDateSelector } from "./components/filter_menu_date_selector.jsx";

// Javascript handlers for the Filter List menu popup

namespace("Slzr.Theme.FilterList", function (exports, top) {
  // import Localist jQuery instance
  const $ = jQuery;

  let filtersOpened = false;
  let moreOptionsOpened = false;
  let minicalendarPopoverOpened = false;
  let focusWas = null;

  // Track temporary mousedown listeners that suppress default focus changes on whitespace
  const mouseDownSuppressors = [];

  function attachMouseDownSuppressor(element) {
    if (!element) return;
    const handler = function (event) {
      // If the click is within the trapped element but not on a focusable descendant,
      // prevent the default focus change that can cause the page to jump.
      if (!element.contains(event.target)) return;
      if (event.target.closest(FocusTrap.FOCUSABLE_SELECTORS)) return;
      event.preventDefault();
    };
    element.addEventListener("mousedown", handler, true);
    mouseDownSuppressors.push({ element, handler });
  }

  function detachMouseDownSuppressors() {
    while (mouseDownSuppressors.length > 0) {
      const { element, handler } = mouseDownSuppressors.pop();
      element.removeEventListener("mousedown", handler, true);
    }
  }

  function saveFocus() {
    focusWas = document.activeElement;
  }

  // Restore focus that was previously stored
  function restoreFocus() {
    // Restore focus
    if (focusWas) {
      focusWas.focus();
      focusWas = null;
    }
  }

  // Click handler to hide opened menu
  function handleClickOutside(event) {
    if (!$(event.target).closest(".em-filter").length) {
      exports.closeFilterDropdown(event, null);
      exports.closeMoreOptions(event, null);
      exports.closeMiniCalendarPopover(event, null);
    }
  }

  // Keydown handler to allow Escape to hide the dropdown or sidebar while it has focus
  function handleEscapeKeydown(event) {
    if (
      !event.target.closest(".em-filter-dropdown") &&
      !event.target.closest(".em-filter-button") &&
      !event.target.closest(".em-filter-more-options")
    ) {
      return;
    }

    switch (event.key) {
      case "Escape":
        if (!event.defaultPrevented) {
          exports.closeFilterDropdown(event, null);
          exports.closeMoreOptions(event, null);
          exports.closeMiniCalendarPopover(event, null);
          event.preventDefault();
        }
        break;
    }
  }

  // Attach event listeners for closing the filter/other items dropdowns
  function addCloseEventListeners() {
    $(document).on("click", handleClickOutside);

    // This listens on window, to avoid taking priority over React event's if this is bound more closely
    window.addEventListener("keydown", handleEscapeKeydown);
  }

  // Remove event listeners added in addCloseEventListeners
  function removeCloseEventListeners() {
    $(document).off("click", handleClickOutside);
    window.removeEventListener("keydown", handleEscapeKeydown);
  }

  // Toggle filter function
  exports.toggleFilterDropdown = function (event, element) {
    if (filtersOpened) {
      exports.closeFilterDropdown(event, element);
    } else {
      exports.openFilterDropdown(event, element);
    }
  };

  // Toggle more menu
  exports.toggleMoreOptions = function (event, element) {
    if (moreOptionsOpened) {
      exports.closeMoreOptions(event, element);
    } else {
      exports.openMoreOptions(event, element);
    }
  };
  // Toggle popover
  exports.toggleMiniCalendarPopover = function (event, element) {
    if (minicalendarPopoverOpened) {
      exports.closeMiniCalendarPopover(event, element);
    } else {
      exports.openMiniCalendarPopover(event, element);
    }
  };

  // Open filter menu
  exports.openFilterDropdown = function (event, element) {
    filtersOpened = true;
    exports.closeMoreOptions(event, element);

    saveFocus();

    const filterDropdown = $("#filter-dropdown");
    const filterDropdownEl = filterDropdown.get(0);
    
    filterDropdown.removeAttr("aria-hidden");

    $('[data-action="toggle-filter-dropdown"]')
      .addClass("em-is-open")
      .attr("aria-expanded", "true");
    
    const windowsize = $(window).width();
    if (windowsize < 768) {
      $("html, body").toggleClass("em-scroll-body");
    }

    FocusTrap.trap(filterDropdownEl);

    // Prevent whitespace clicks inside the dropdown from shifting focus and scrolling the page
    attachMouseDownSuppressor(filterDropdownEl);

    addCloseEventListeners();
    
    // Show the dialog
    filterDropdown.fadeToggle("fast", "linear", () => {
      // Use requestAnimationFrame to ensure DOM is fully updated
      requestAnimationFrame(() => {
        // First, make the dialog container focusable and focus it to ensure VoiceOver recognizes the dialog
        filterDropdownEl.setAttribute("tabindex", "-1");
        filterDropdownEl.focus();
        
        // After VoiceOver has time to announce the dialog, move focus directly to close button
        setTimeout(() => {
          if (!filtersOpened) return;
          filterDropdownEl.removeAttribute("tabindex");
          const closeButton = document.getElementById("em-filter-dropdown-close");
          if (closeButton) {
            closeButton.focus();
            return;
          }

          // For template backwards compatibility, just focus the first focusable element
          const firstFocusable = document.querySelector("#filter-dropdown form input:not([type='hidden']), #filter-dropdown form select");
          if (firstFocusable) {
            firstFocusable.focus();
          }
        }, 500);
      });
    });
  };

  // Close filter menu
  exports.closeFilterDropdown = function (event, element) {
    if (filtersOpened) {
      filtersOpened = false;

      FocusTrap.untrap();
      const filterDropdown = $("#filter-dropdown");
      
      filterDropdown.attr("aria-hidden", "true");
      filterDropdown.hide();
      $('[data-action="toggle-filter-dropdown"]')
        .removeClass("em-is-open")
        .attr("aria-expanded", "false");
      $("html, body").removeClass("em-scroll-body");
      restoreFocus();
      detachMouseDownSuppressors();
      removeCloseEventListeners();
    }
  };

  // Open more options menu
  exports.openMoreOptions = function (event, element) {
    moreOptionsOpened = true;
    exports.closeFilterDropdown(event, element);

    const moreOptionsDropdown = $("#more-options-dropdown");
    const moreOptionsEl = moreOptionsDropdown.get(0);
    
    moreOptionsDropdown.removeAttr("aria-hidden");

    $('[data-action="toggle-more-options"]')
      .addClass("em-is-open")
      .attr("aria-expanded", "true");
    
    const windowsize = $(window).width();
    if (windowsize < 768) {
      $("html, body").toggleClass("em-scroll-body");
    }

    saveFocus();
    
    FocusTrap.trap(moreOptionsEl);
    // Prevent whitespace clicks inside the drawer from shifting focus and scrolling the page
    attachMouseDownSuppressor(moreOptionsEl);
    addCloseEventListeners();
    
    // Show the dialog
    moreOptionsDropdown
      .hide()
      .show("slide", { direction: "right" }, 250, () => {
        // Use requestAnimationFrame to ensure DOM is fully updated
        requestAnimationFrame(() => {
          // First, make the dialog container focusable and focus it to ensure VoiceOver recognizes the dialog
          moreOptionsEl.setAttribute("tabindex", "-1");
          moreOptionsEl.focus();
          
          // After VoiceOver has time to announce the dialog, move focus directly to close link
          setTimeout(() => {
            if (!moreOptionsOpened) return;
            moreOptionsEl.removeAttribute("tabindex");
            if (moreOptionsEl) {
              const closeLink = moreOptionsEl.querySelector("a[data-action='close-more-options']");
              if (closeLink) {
                closeLink.focus();
              } else {
                const firstFocusable = moreOptionsEl.querySelector("input, select, a");
                if (firstFocusable) {
                  firstFocusable.focus();
                }
              }
            }
          }, 500);
        });
      });
  };

  // Close more options menu
  exports.closeMoreOptions = function (event, element) {
    if (moreOptionsOpened) {
      moreOptionsOpened = false;
      FocusTrap.untrap();
      const moreOptionsDropdown = $("#more-options-dropdown");
      
      moreOptionsDropdown.attr("aria-hidden", "true");
      moreOptionsDropdown.hide();
      $('[data-action="toggle-more-options"]')
        .removeClass("em-is-open")
        .attr("aria-expanded", "false");
      $("html, body").removeClass("em-scroll-body");
      restoreFocus();
      detachMouseDownSuppressors();
      removeCloseEventListeners();
    }
  };

  // Open popover
  exports.openMiniCalendarPopover = function (event, element) {
    minicalendarPopoverOpened = true;
    exports.closeFilterDropdown(event, element);
    exports.closeMoreOptions(event, element);

    const miniCalendar = $("#mini-calendar");
    const miniCalendarEl = miniCalendar.get(0);
    
    miniCalendar.removeAttr("aria-hidden");

    $('[data-action="toggle-mini-calendar"]')
      .addClass("em-is-open")
      .attr("aria-expanded", "true");
    
    const windowsize = $(window).width();
    if (windowsize < 768) {
      $("html, body").toggleClass("em-scroll-body");
    }

    saveFocus();

    const emQuickDatePickerContainer = $("#em-quick-date-picker-container").get(
      0,
    );

    FocusTrap.trap(emQuickDatePickerContainer);

    // Prevent whitespace clicks inside the popover from shifting focus and scrolling the page
    attachMouseDownSuppressor(emQuickDatePickerContainer);

    addCloseEventListeners();
    
    // Show the dialog
    miniCalendar.fadeToggle("fast", "linear", () => {
      // Use requestAnimationFrame to ensure DOM is fully updated
      requestAnimationFrame(() => {
        // First, make the dialog container focusable and focus it to ensure VoiceOver recognizes the dialog
        miniCalendarEl.setAttribute("tabindex", "-1");
        miniCalendarEl.focus();
        
        // After VoiceOver has time to announce the dialog, move focus directly to first interactive element
        setTimeout(() => {
          if (!minicalendarPopoverOpened) return;
          if (miniCalendarEl) {
            miniCalendarEl.removeAttribute("tabindex");
            const focusableElements = miniCalendarEl.querySelectorAll("input, select, a, .DayPicker-wrapper, button");
            if (focusableElements.length > 0) {
              focusableElements[0].focus();
            }
          }
        }, 500);
      });
    });
  };

  // Close popover
  exports.closeMiniCalendarPopover = function (event, element) {
    if (minicalendarPopoverOpened) {
      minicalendarPopoverOpened = false;
      FocusTrap.untrap();
      const miniCalendar = $("#mini-calendar");

      miniCalendar.attr("aria-hidden", "true");
      miniCalendar.hide();
      $('[data-action="toggle-mini-calendar"]')
        .removeClass("em-is-open")
        .attr("aria-expanded", "false");
      $("html, body").removeClass("em-scroll-body");
      restoreFocus();
      detachMouseDownSuppressors();
      removeCloseEventListeners();
    }
  };

  // Prevent focus changes when clicking Filter button while modal is open
  function handleFilterButtonMouseDown(event) {
    if (filtersOpened) {
      event.preventDefault();
    }
  }

  // Prevent focus changes when clicking More Options button while modal is open
  function handleMoreOptionsButtonMouseDown(event) {
    if (moreOptionsOpened) {
      event.preventDefault();
    }
  }

  $(document).ready(function () {
    // Attach toggle handlers
    $('[data-action="toggle-filter-dropdown"]').on("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      Slzr.Theme.FilterList.toggleFilterDropdown(event, this);
    });

    // Prevent focus changes when clicking Filter button while modal is open
    $('[data-action="toggle-filter-dropdown"]').on(
      "mousedown",
      handleFilterButtonMouseDown,
    );

    $('[data-action="close-filter-dropdown"]').on("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      Slzr.Theme.FilterList.closeFilterDropdown(event, this);
    });

    $('[data-action="toggle-more-options"]').on("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      Slzr.Theme.FilterList.toggleMoreOptions(event, this);
    });

    // Prevent focus changes when clicking More Options button while modal is open
    $('[data-action="toggle-more-options"]').on(
      "mousedown",
      handleMoreOptionsButtonMouseDown,
    );

    $('[data-action="close-more-options"]').on("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      Slzr.Theme.FilterList.closeMoreOptions(event, this);
    });

    $('[data-action="toggle-mini-calendar"]').on("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      Slzr.Theme.FilterList.toggleMiniCalendarPopover(event, this);
    });

    // Initialize the filter select elements
    $("[data-filter-select]").multiSelect({
      containerHTML: '<div class="em-select-input">',
      buttonHTML:
        '<button type="button" class="em-select-fallback em-ellipsis">',
      menuHTML: '<div class="em-multi-select-menu em-dropdown-container">',
      menuItemHTML: '<label class="em-checkbox em-dropdown-item">',
      noneText: "All",
    });

    // Initialize date selector
    const filter_form = $("[data-filter-menu]");
    // Store the base URL if it's in action
    filter_form.data("base-url", filter_form.attr("action"));

    const start = filter_form.data("filter-start-date")
      ? moment(filter_form.data("filter-start-date"))
      : moment();
    const end = filter_form.data("filter-end-date")
      ? moment(filter_form.data("filter-end-date"))
      : moment().add(6, "days");

    // Apply logic to use smart calendar URLs for event filter menus
    if (
      filter_form.data("filter-menu-type") === "events" &&
      filter_form.data("filter-menu-mode") !== "search"
    ) {
      filter_form.on("submit", function (event) {
        let base_url = filter_form.data("base-url"); // base calendar URL to build from
        let view_type = "day"; // calendar "view" type, day/week/month/upcoming
        let append_date = true; // true to append start date to the URL as path segments
        let want_days = true; // true if the days parameter is wanted

        // Build the calendar URL
        //
        // When possible, this converts the user's date selection into one of our predefined types: day/week/month/upcoming
        //
        // Note that the date range the user selected is inclusive, that is, it's from start_date 00:00:00 to
        // end_date 23:59:59, so the date count is one less than may be expected.

        const start_date = filter_form.data("start-date");
        const num_days = filter_form.data("days");

        if (moment().isSame(start_date, "day")) {
          // If it's starting today, the date can be left off
          append_date = false;

          if (num_days === 29) {
            // next 30
            view_type = "upcoming";
            want_days = false;
          }
        }

        // for a week view calendar, don't include the days param
        if (num_days === 6) {
          view_type = "week";
          want_days = false;
        }

        // append the view and start date to the URL
        base_url += `/${view_type}`;
        if (append_date) {
          base_url += `/${start_date.year()}/${start_date.month() + 1}/${start_date.date()}`; // moment's month is 0 based
        }

        // Disable the start_date input
        filter_form
          .find('[data-filter-menu-item="start_date"]')
          .prop("disabled", true);
        // Enable the days input unless it's covered by another URL segment
        filter_form
          .find('[data-filter-menu-item="days"]')
          .prop("disabled", !want_days);
        filter_form.attr("action", base_url);
      });
    }

    // TODO: Remove old date picker
    function selectedDateChanged(start, end, label) {
      // update displayed label
      $("#reportrange span").html(
        `${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`,
      );

      // update date range fields and properties
      filter_form.data({
        "date-range": label,
        "start-date": start,
        "end-date": end,
        days: end.diff(start, "d"),
      });

      $('#filter-dropdown [data-filter-menu-item="start_date"]').val(
        start.format("YYYY-MM-DD"),
      );
      // The backend needs this to be a minimum of 1 for a single-date page
      $('#filter-dropdown [data-filter-menu-item="days"]').val(
        end.diff(start, "d") + 1,
      );

      // hide date picker
      $(".daterangepicker").fadeOut();
    }

    // Callback for the user selecting a date range
    function handleDateSelection(start, end) {
      filter_form.data({
        "start-date": start,
        "end-date": end,
        days: end.diff(start, "d"),
      });

      // Set fields the URL needs
      $('#filter-dropdown [data-filter-menu-item="start_date"]').val(
        start.format("YYYY-MM-DD"),
      );
      // The backend needs this to be a minimum of 1 for a single-date page
      $('#filter-dropdown [data-filter-menu-item="days"]').val(
        end.diff(start, "d") + 1,
      );
    }

    function getPlatformDefaultCalendarView() {
      const platform_default = LOCALIST_SETTINGS.default_calendar_view;

      // Labels should match platform default calendar view list language
      switch (platform_default) {
        case "three_months":
          return {
            label: "Next 3 Months",
            days: calculateDaysInRange(3, "months"),
          };
        case "six_months":
          return {
            label: "Next 6 Months",
            days: calculateDaysInRange(6, "months"),
          };
        case "year":
          return {
            label: "Next 12 Months",
            days: calculateDaysInRange(12, "months"),
          };
      }
    }

    // Calculate specific calendar days for a time frame
    // num is number of units
    // units is 'days', 'months' or 'years
    function calculateDaysInRange(num, units) {
      const now = moment();

      return moment(now).add(num, units).diff(now, "days");
    }

    // Initialize date picker menu and mount the react component
    const dateMenuElement = $(
      '#filter-dropdown [data-filter-menu-item="date-menu"]',
    );
    if (dateMenuElement.length > 0) {
      // No JSX here
      ReactDOM.render(
        React.createElement(FilterMenuDateSelector, {
          start: start,
          end: end,
          onDateSelected: handleDateSelection,
          defaultCalendarView: getPlatformDefaultCalendarView(),
        }),
        dateMenuElement.get(0),
      );
    }

    //TODO: Remove old date picker
    new DateRangePicker(
      $("#reportrange"),
      {
        autoUpdateInput: false,
        autoApply: true,
        startDate: start,
        endDate: end,
        parentEl: $("#select-input-calendar"),
        showCustomRangeLabel: true,
        linkedCalendars: false,
        alwaysShowCalendars: false,
        locale: {
          customRangeLabel: "Select date on a calendar",
        },
        ranges: {
          Today: [moment(), moment()],
          // Note: last date is inclusive, so 6 days = a week, not 7
          "Next 7 days": [moment(), moment().add(6, "days")],
          "Next 30 days": [moment(), moment().add(29, "days")],
        },
        maxSpan: {
          days: 6,
        },
      },
      selectedDateChanged,
    );

    selectedDateChanged(start, end);
  });
}); // end namespace
